import { filterInstitutionRows } from "../../../shared/sessionCache.js";
import React, { useState, useMemo, useEffect } from "react";
import BuscaAluno from "../../../components/SearchStudents";
import api from "../../../services/api";
import {
  CRITERIOS_DESAFIO_LEGADO,
  getCriteriosDesafio,
} from "../../../shared/constants";
import {
  calcularCriterio,
  fmtDateFull,
  fmtNum,
  todayISO,
} from "../../../shared/utils";
export default function Desafios(props) {
  let currentStudent = props.currentStudent;
  let students = props.students;
  let batalhas = props.batalhas;
  let setBatalhas = props.setBatalhas;
  let getTokensDisponiveis = props.getTokensDisponiveis;
  let checkpoints = filterInstitutionRows(props.checkpoints, currentStudent);
  let checkpointsComAutomaticos = filterInstitutionRows(
    props.checkpointsComAutomaticos,
    currentStudent,
  );
  let activities = props.activities;
  let showFlash = props.showFlash;
  const [aba, setAba] = useState("pendentes");
  const criterios = useMemo(
    () => getCriteriosDesafio(activities),
    [activities],
  );
  const [form, setForm] = useState({
    desafiado_id: 0,
    aposta: "",
    criterio: "pontos",
    data_fim: "",
    descricao: "",
  });
  const hoje = todayISO();
  const amanha = new Date(Date.now() + 864e5).toISOString().slice(0, 10);
  const toBattlePayload = (battle) => {
    return {
      desafiante_id: Number(battle.desafiante_id),
      desafiado_id: Number(battle.desafiado_id),
      aposta: Number(battle.aposta),
      criterio: battle.criterio,
      criterio_label: battle.criterio_label,
      data_inicio: battle.data_inicio,
      data_fim: battle.data_fim,
      descricao: battle.descricao || "",
      status: battle.status,
      criado_em: Number(battle.criado_em) || Date.now(),
      vencedor_id: battle.vencedor_id ?? null,
      perdedor_id: battle.perdedor_id ?? null,
      val_desafiante: battle.val_desafiante ?? null,
      val_desafiado: battle.val_desafiado ?? null,
    };
  };
  const bats = useMemo(
    () =>
      filterInstitutionRows(batalhas, currentStudent).map((itemStatus) => {
        if (
          "aceita" !== itemStatus.status ||
          !itemStatus.data_fim ||
          itemStatus.data_fim >= hoje ||
          itemStatus._processado
        )
          return itemStatus;
        const valorDesafiante = calcularCriterio(
          itemStatus.criterio,
          itemStatus.desafiante_id,
          itemStatus.data_inicio,
          itemStatus.data_fim,
          checkpoints,
          activities,
          checkpointsComAutomaticos,
        );
        const vD2 = calcularCriterio(
          itemStatus.criterio,
          itemStatus.desafiado_id,
          itemStatus.data_inicio,
          itemStatus.data_fim,
          checkpoints,
          activities,
          checkpointsComAutomaticos,
        );
        if (valorDesafiante === vD2)
          return {
            ...itemStatus,
            status: "empate",
            _processado: true,
            val_desafiante: valorDesafiante,
            val_desafiado: vD2,
          };
        const vencedorId =
          valorDesafiante > vD2
            ? itemStatus.desafiante_id
            : itemStatus.desafiado_id;
        const perdedorId =
          valorDesafiante > vD2
            ? itemStatus.desafiado_id
            : itemStatus.desafiante_id;
        return {
          ...itemStatus,
          status: "finalizada",
          vencedor_id: vencedorId,
          perdedor_id: perdedorId,
          _processado: true,
          val_desafiante: valorDesafiante,
          val_desafiado: vD2,
        };
      }),
    [
      batalhas,
      checkpoints,
      checkpointsComAutomaticos,
      activities,
      hoje,
      currentStudent?.casa_id,
    ],
  );
  useEffect(() => {
    const alteradas = bats.filter((bat) => {
      const atual = batalhas.find((batalha) => batalha.id === bat.id);
      return (
        !!atual &&
        (atual.status !== bat.status ||
          (atual.vencedor_id ?? null) !== (bat.vencedor_id ?? null) ||
          (atual.perdedor_id ?? null) !== (bat.perdedor_id ?? null) ||
          (atual.val_desafiante ?? null) !== (bat.val_desafiante ?? null) ||
          (atual.val_desafiado ?? null) !== (bat.val_desafiado ?? null))
      );
    });
    if (0 === alteradas.length) return;
    let ativo = true;
    (async () => {
      try {
        let atualizadas = [];
        try {
          const atualizadasRaw =
            (
              await api.put("/batalhas/lote", {
                items: alteradas.map((alterada) => ({
                  id: alterada.id,
                  ...toBattlePayload(alterada),
                })),
              })
            ).data?.data ?? [];
          atualizadas = Array.isArray(atualizadasRaw)
            ? atualizadasRaw
            : [atualizadasRaw];
        } catch (err) {
          if (![404, 405].includes(err.response?.status)) throw err;
          atualizadas = (
            await Promise.all(
              alteradas.map((alterada) =>
                api.put(
                  "/batalhas?id=".concat(alterada.id),
                  toBattlePayload(alterada),
                ),
              ),
            )
          ).map((res) => {
            return res.data?.data ?? res.data;
          });
        }
        if (!ativo) return;
        const byId = new Map(atualizadas.map((itemId) => [itemId.id, itemId]));
        setBatalhas((prev) =>
          prev.map((itemId) => byId.get(itemId.id) || itemId),
        );
      } catch (error) {
        if (!ativo) return;
        setBatalhas(batalhas);
      }
    })();
    return () => {
      ativo = false;
    };
  }, [bats, batalhas, setBatalhas]);
  const meuDisp = Math.max(0, getTokensDisponiveis(currentStudent.id));
  const pendParaMim = bats.filter(
    (bat) =>
      "aguardando" === bat.status && bat.desafiado_id === currentStudent.id,
  );
  const enviados = bats.filter(
    (bat) =>
      "aguardando" === bat.status && bat.desafiante_id === currentStudent.id,
  );
  const ativos = bats.filter(
    (bat) =>
      "aceita" === bat.status &&
      (bat.desafiante_id === currentStudent.id ||
        bat.desafiado_id === currentStudent.id),
  );
  const finalizados = bats.filter(
    (bat) =>
      ("finalizada" === bat.status || "empate" === bat.status) &&
      (bat.desafiante_id === currentStudent.id ||
        bat.desafiado_id === currentStudent.id),
  );
  const diasRestantes = (dataFim) => {
    const quantidadeDias = Math.ceil((new Date(dataFim) - new Date()) / 864e5);
    return quantidadeDias > 0
      ? ""
          .concat(quantidadeDias, "d restante")
          .concat(quantidadeDias > 1 ? "s" : "")
      : 0 === quantidadeDias
        ? "Encerra hoje"
        : "Encerrado";
  };
  return (
    <div className={"cn"}>
      <h1 className={"pt"}>
        <em>{"Desafios"}</em>
      </h1>
      <div className={"ps"}>
        {"Aposte tokens — o sistema decide o vencedor automaticamente"}
      </div>
      <div
        style={{
          background: "rgba(255,255,255,0.1)",
          borderRadius: 11,
          padding: "11px 14px",
          marginBottom: 14,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 10,
              color: "rgba(255,255,255,0.55)",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: ".12em",
            }}
          >
            {"Tokens disponíveis"}
          </div>
          <div
            style={{
              fontSize: 22,
              fontWeight: 800,
              color: "#FFC76B",
            }}
          >
            {fmtNum(meuDisp)}{" "}
            <small
              style={{
                fontSize: 11,
              }}
            >
              {"Tokens"}
            </small>
          </div>
        </div>
        {pendParaMim.length > 0 && (
          <span
            style={{
              background: "#D9534F",
              color: "#FFF",
              borderRadius: 999,
              padding: "5px 13px",
              fontSize: 12,
              fontWeight: 800,
            }}
          >
            {pendParaMim.length}
            {" te desafia!"}
          </span>
        )}
      </div>
      <div className={"tabs"}>
        <button
          className={"pendentes" === aba ? "a" : ""}
          onClick={() => setAba("pendentes")}
        >
          {"Para mim"}
          {pendParaMim.length > 0 && (
            <span className={"nb"}>{pendParaMim.length}</span>
          )}
        </button>
        <button
          className={"novo" === aba ? "a" : ""}
          onClick={() => setAba("novo")}
        >
          {"+ Novo"}
        </button>
        <button
          className={"ativos" === aba ? "a" : ""}
          onClick={() => setAba("ativos")}
        >
          {"Ativos ("}
          {ativos.length}
          {")"}
        </button>
        <button
          className={"hist" === aba ? "a" : ""}
          onClick={() => setAba("hist")}
        >
          {"Histórico"}
        </button>
      </div>
      {"pendentes" === aba && (
        <div>
          <div className={"dv dv-dark"}>
            <span>
              {"Desafios Recebidos ("}
              {pendParaMim.length}
              {")"}
            </span>
          </div>
          {0 === pendParaMim.length ? (
            <div className={"es"}>
              <h3>{"Nenhum desafio pendente"}</h3>
              <p>{"Ninguem te desafiou ainda. Que tal desafiar alguem?"}</p>
              <p
                style={{
                  marginTop: 12,
                }}
              >
                <button className={"btn"} onClick={() => setAba("novo")}>
                  {"Criar Desafio"}
                </button>
              </p>
            </div>
          ) : (
            pendParaMim.map((pendParaMimDesafiante_id) => {
              const des = students.find(
                (student) =>
                  student.id === pendParaMimDesafiante_id.desafiante_id,
              );
              const oponDisp = Math.max(
                0,
                getTokensDisponiveis(currentStudent.id),
              );
              return (
                <div
                  className={"desafio-card"}
                  key={pendParaMimDesafiante_id.id}
                >
                  <div
                    style={{
                      fontSize: 15,
                      fontWeight: 800,
                      color: "#1F4754",
                      marginBottom: 8,
                    }}
                  >
                    {des?.nome}
                    {" te desafiou!"}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 4,
                      marginBottom: 12,
                    }}
                  >
                    <div
                      style={{
                        fontSize: 13,
                        color: "#2A5868",
                      }}
                    >
                      <strong>{"Criterio:"}</strong>{" "}
                      {pendParaMimDesafiante_id.criterio_label}
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        color: "#2A5868",
                      }}
                    >
                      <strong>{"Encerra em:"}</strong>{" "}
                      {fmtDateFull(pendParaMimDesafiante_id.data_fim)}
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        color: "#2A5868",
                      }}
                    >
                      <strong>{"Aposta:"}</strong>{" "}
                      <span
                        style={{
                          color: "#FF8C42",
                          fontWeight: 800,
                        }}
                      >
                        {fmtNum(pendParaMimDesafiante_id.aposta)}
                        {" tokens cada"}
                      </span>
                    </div>
                    <div
                      style={{
                        fontSize: 13,
                        color: "#2A5868",
                      }}
                    >
                      <strong>{"Vencedor leva:"}</strong>{" "}
                      <span
                        style={{
                          color: "#4FB3A9",
                          fontWeight: 800,
                        }}
                      >
                        {fmtNum(2 * pendParaMimDesafiante_id.aposta)}
                        {" tokens"}
                      </span>
                    </div>
                    {pendParaMimDesafiante_id.descricao && (
                      <div
                        style={{
                          fontSize: 12,
                          color: "#6B8590",
                          fontStyle: "italic",
                        }}
                      >
                        {'"'}
                        {pendParaMimDesafiante_id.descricao}
                        {'"'}
                      </div>
                    )}
                  </div>
                  {oponDisp < pendParaMimDesafiante_id.aposta ? (
                    <div
                      className={"fl2 er"}
                      style={{
                        fontSize: 12,
                      }}
                    >
                      {"Tokens insuficientes ("}
                      {fmtNum(oponDisp)}
                      {" disponíveis, precisa de "}
                      {fmtNum(pendParaMimDesafiante_id.aposta)}
                      {")."}
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                      }}
                    >
                      <button
                        className={"btn"}
                        style={{
                          flex: 1,
                          fontSize: 12,
                        }}
                        onClick={() =>
                          (async (itemAposta) => {
                            if (parseInt(itemAposta.aposta, 10) > meuDisp)
                              return showFlash(
                                "Tokens insuficientes para aceitar.",
                                "er",
                              );
                            const atualizado = {
                              ...itemAposta,
                              status: "aceita",
                            };
                            try {
                              const responseData2 = await api.put(
                                "/batalhas?id=".concat(itemAposta.id),
                                toBattlePayload(atualizado),
                              );
                              const saved =
                                responseData2.data?.data ?? responseData2.data;
                              setBatalhas(
                                bats.map((bat) =>
                                  bat.id === itemAposta.id ? saved : bat,
                                ),
                              );
                              showFlash(
                                "Desafio aceito! Criterio: "
                                  .concat(
                                    itemAposta.criterio_label,
                                    ". Encerra em ",
                                  )
                                  .concat(
                                    fmtDateFull(itemAposta.data_fim),
                                    ".",
                                  ),
                              );
                            } catch (err) {
                              showFlash(
                                err.response?.data?.message ||
                                  "Nao foi possivel aceitar o desafio.",
                                "er",
                              );
                            }
                          })(pendParaMimDesafiante_id)
                        }
                      >
                        {"Aceitar Desafio"}
                      </button>
                      <button
                        className={"btn bd"}
                        style={{
                          flex: 1,
                          fontSize: 12,
                        }}
                        onClick={() =>
                          (async (itemId) => {
                            const atualizado = {
                              ...itemId,
                              status: "recusada",
                            };
                            try {
                              const responseData2 = await api.put(
                                "/batalhas?id=".concat(itemId.id),
                                toBattlePayload(atualizado),
                              );
                              const saved =
                                responseData2.data?.data ?? responseData2.data;
                              setBatalhas(
                                bats.map((bat) =>
                                  bat.id === itemId.id ? saved : bat,
                                ),
                              );
                              showFlash("Desafio recusado.", "in");
                            } catch (err) {
                              showFlash(
                                err.response?.data?.message ||
                                  "Nao foi possivel recusar o desafio.",
                                "er",
                              );
                            }
                          })(pendParaMimDesafiante_id)
                        }
                      >
                        {"Recusar"}
                      </button>
                    </div>
                  )}
                </div>
              );
            })
          )}
          {enviados.length > 0 && (
            <React.Fragment>
              <div className={"dv dv-dark"}>
                <span>
                  {"Enviados por mim ("}
                  {enviados.length}
                  {")"}
                </span>
              </div>
              {enviados.map((enviado) => {
                const dest = students.find(
                  (student) => student.id === enviado.desafiado_id,
                );
                return (
                  <div
                    style={{
                      background: "rgba(255,255,255,0.08)",
                      borderRadius: 10,
                      padding: "10px 12px",
                      marginBottom: 6,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    key={enviado.id}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: "rgba(255,255,255,0.9)",
                        }}
                      >
                        {"Para "}
                        {dest?.nome}
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          color: "rgba(255,255,255,0.5)",
                          marginTop: 2,
                        }}
                      >
                        {enviado.criterio_label}
                        {" - "}
                        {fmtNum(enviado.aposta)}
                        {" tokens - ate"} {fmtDateFull(enviado.data_fim)}
                      </div>
                    </div>
                    <button
                      className={"btn bd bs"}
                      style={{
                        fontSize: 11,
                      }}
                      onClick={() =>
                        (async (itemId) => {
                          const atualizado = {
                            ...itemId,
                            status: "cancelada",
                          };
                          try {
                            const responseData2 = await api.put(
                              "/batalhas?id=".concat(itemId.id),
                              toBattlePayload(atualizado),
                            );
                            const saved =
                              responseData2.data?.data ?? responseData2.data;
                            setBatalhas(
                              bats.map((bat) =>
                                bat.id === itemId.id ? saved : bat,
                              ),
                            );
                            showFlash("Desafio cancelado.", "in");
                          } catch (err) {
                            showFlash(
                              err.response?.data?.message ||
                                "Nao foi possivel cancelar o desafio.",
                              "er",
                            );
                          }
                        })(enviado)
                      }
                    >
                      {"Cancelar"}
                    </button>
                  </div>
                );
              })}
            </React.Fragment>
          )}
        </div>
      )}
      {"novo" === aba && (
        <form
          onSubmit={async (event) => {
            event.preventDefault();
            if (!form.desafiado_id)
              return showFlash("Selecione o oponente.", "er");
            const aposta = parseInt(form.aposta, 10);
            if (!aposta || aposta <= 0)
              return showFlash("Informe a aposta.", "er");
            if (aposta > meuDisp)
              return showFlash(
                "Você tem apenas ".concat(
                  fmtNum(meuDisp),
                  " tokens disponíveis.",
                ),
                "er",
              );
            if (!form.data_fim || form.data_fim <= hoje)
              return showFlash("Data deve ser futura.", "er");
            const opon = students.find(
              (student) => student.id === Number(form.desafiado_id),
            );
            const oponDisp = Math.max(0, getTokensDisponiveis(opon.id));
            if (aposta > oponDisp)
              return showFlash(
                ""
                  .concat(opon.nome, " nao tem tokens suficientes (tem ")
                  .concat(fmtNum(oponDisp), ")."),
                "er",
              );
            const crit = criterios.find(
              (criterio) => criterio.id === form.criterio,
            );
            const novo = {
              desafiante_id: currentStudent.id,
              desafiado_id: Number(form.desafiado_id),
              aposta,
              criterio: form.criterio,
              criterio_label: crit.label,
              data_inicio: hoje,
              data_fim: form.data_fim,
              descricao: form.descricao.trim(),
              status: "aguardando",
              criado_em: Date.now(),
              vencedor_id: null,
              perdedor_id: null,
              val_desafiante: null,
              val_desafiado: null,
            };
            try {
              const responseData2 = await api.post(
                "/batalhas",
                toBattlePayload(novo),
              );
              const saved = responseData2.data?.data ?? responseData2.data;
              setBatalhas([...bats, saved]);
              showFlash(
                "Desafio enviado para "
                  .concat(opon.nome, "! Criterio: ")
                  .concat(crit.label),
              );
              setForm({
                desafiado_id: 0,
                aposta: "",
                criterio: "pontos",
                data_fim: "",
                descricao: "",
              });
              setAba("pendentes");
            } catch (err) {
              showFlash(
                err.response?.data?.message ||
                  "Nao foi possivel enviar o desafio.",
                "er",
              );
            }
          }}
          className={"fc"}
        >
          <div
            style={{
              fontWeight: 800,
              color: "#1F4754",
              fontSize: 15,
              marginBottom: 13,
            }}
          >
            {"Propor Desafio"}
          </div>
          <div className={"fg"}>
            <label>{"Oponente"}</label>
            <BuscaAluno
              students={students.filter(
                (student) => student.ativo && student.id !== currentStudent.id,
              )}
              value={form.desafiado_id}
              onChange={(resultado) =>
                setForm({
                  ...form,
                  desafiado_id: resultado,
                })
              }
              placeholder={"Buscar aluno para desafiar..."}
            />
          </div>
          {form.desafiado_id > 0 && (
            <div
              style={{
                fontSize: 12,
                color: "#6B8590",
                marginBottom: 10,
                marginTop: -6,
              }}
            >
              {"Tokens de"}{" "}
              {
                students
                  .find((student) => student.id === form.desafiado_id)
                  ?.nome.split(" ")[0]
              }
              {": "}
              {fmtNum(Math.max(0, getTokensDisponiveis(form.desafiado_id)))}
            </div>
          )}
          <div className={"fg"}>
            <label>
              {"Criterio de vitoria (o sistema avalia automaticamente)"}
            </label>
            <select
              className={"sel"}
              value={form.criterio}
              onChange={(event) =>
                setForm({
                  ...form,
                  criterio: event.target.value,
                })
              }
              required={true}
            >
              {criterios.map((criterio) => (
                <option value={criterio.id} key={criterio.id}>
                  {criterio.label}
                </option>
              ))}
            </select>
            <div
              style={{
                fontSize: 11,
                color: "#6B8590",
                marginTop: 4,
              }}
            >
              {"Quem tiver mais ao encerrar, vence e leva os tokens apostados."}
            </div>
          </div>
          <div className={"fg"}>
            <label>{"Data de encerramento"}</label>
            <input
              type={"date"}
              className={"inp"}
              value={form.data_fim}
              min={amanha}
              onChange={(event) =>
                setForm({
                  ...form,
                  data_fim: event.target.value,
                })
              }
              required={true}
            />
          </div>
          <div className={"fg"}>
            <label>
              {"Aposta (tokens — ambos apostam a mesma quantidade)"}
            </label>
            <input
              type={"number"}
              min={"1"}
              max={meuDisp}
              className={"inp"}
              value={form.aposta}
              onChange={(event) =>
                setForm({
                  ...form,
                  aposta: event.target.value,
                })
              }
              placeholder={"Max: ".concat(fmtNum(meuDisp), " tokens")}
              required={true}
            />
            {form.aposta > 0 && parseInt(form.aposta, 10) <= meuDisp && (
              <div
                style={{
                  marginTop: 6,
                  fontSize: 12,
                  color: "#1A7A6E",
                  background: "#E0F5F0",
                  padding: "7px 10px",
                  borderRadius: 8,
                }}
              >
                {"Vencedor recebe"}{" "}
                <strong>
                  {fmtNum(2 * parseInt(form.aposta, 10))}
                  {" tokens"}
                </strong>{" "}
                {"no total"}
              </div>
            )}
          </div>
          <div className={"fg"}>
            <label>{"Descrição (opcional)"}</label>
            <textarea
              className={"tea"}
              value={form.descricao}
              onChange={(event) =>
                setForm({
                  ...form,
                  descricao: event.target.value,
                })
              }
              placeholder={"Ex: Desafio de questões da semana do ENEM!"}
              style={{
                minHeight: 50,
              }}
            />
          </div>
          <button type={"submit"} className={"btn bor bb"}>
            {"Enviar Desafio"}
          </button>
        </form>
      )}
      {"ativos" === aba && (
        <div>
          <div className={"dv dv-dark"}>
            <span>
              {"Em Andamento ("}
              {ativos.length}
              {")"}
            </span>
          </div>
          {0 === ativos.length ? (
            <div className={"es"}>
              <h3>{"Nenhum desafio ativo"}</h3>
              <p>{"Aceite um desafio ou crie um novo."}</p>
            </div>
          ) : (
            ativos.map((ativo) => {
              const oponId =
                ativo.desafiante_id === currentStudent.id
                  ? ativo.desafiado_id
                  : ativo.desafiante_id;
              const opon = students.find((student) => student.id === oponId);
              const meuVal = calcularCriterio(
                ativo.criterio,
                currentStudent.id,
                ativo.data_inicio,
                hoje,
                checkpoints,
                activities,
                checkpointsComAutomaticos,
              );
              const oponVal = calcularCriterio(
                ativo.criterio,
                oponId,
                ativo.data_inicio,
                hoje,
                checkpoints,
                activities,
                checkpointsComAutomaticos,
              );
              const euNaFrente = meuVal > oponVal;
              const empate = meuVal === oponVal;
              const crit = ((criterioId) => {
                if ("pontos" === criterioId)
                  return {
                    unidade: "ponto",
                  };
                const porAtividade = (activities || []).find(
                  (itemId) => String(itemId.id) === String(criterioId),
                );
                return porAtividade
                  ? {
                      unidade: porAtividade.unidade,
                    }
                  : criterios.find((criterio) => criterio.id === criterioId) ||
                      CRITERIOS_DESAFIO_LEGADO.find(
                        (criterio) => criterio.id === criterioId,
                      );
              })(ativo.criterio);
              return (
                <div
                  className={"desafio-card"}
                  style={{
                    border: "1.5px solid rgba(255,140,66,0.4)",
                  }}
                  key={ativo.id}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      marginBottom: 6,
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 800,
                          color: "#1F4754",
                        }}
                      >
                        {"vs "}
                        {opon?.nome}
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          color: "#6B8590",
                          marginTop: 2,
                        }}
                      >
                        {ativo.criterio_label}
                      </div>
                    </div>
                    <span
                      style={{
                        background:
                          ativo.data_fim < hoje ? "#FFE5E0" : "#FFF1DD",
                        color: ativo.data_fim < hoje ? "#B83A2E" : "#B8651E",
                        borderRadius: 999,
                        padding: "3px 9px",
                        fontSize: 10,
                        fontWeight: 700,
                      }}
                    >
                      {diasRestantes(ativo.data_fim)}
                    </span>
                  </div>
                  <div className={"placar"}>
                    <div
                      className={"placar-lado"}
                      style={{
                        background: euNaFrente
                          ? "#E0F5F0"
                          : empate
                            ? "#F4F8F9"
                            : "#FFE5E0",
                      }}
                    >
                      <div className={"placar-nome"}>{"Você"}</div>
                      <div
                        className={"placar-val"}
                        style={{
                          color: euNaFrente
                            ? "#1A7A6E"
                            : empate
                              ? "#1F4754"
                              : "#B83A2E",
                        }}
                      >
                        {fmtNum(meuVal, 1)}
                      </div>
                    </div>
                    <div
                      style={{
                        color: "#B8C5CC",
                        fontWeight: 800,
                        fontSize: 14,
                      }}
                    >
                      {"VS"}
                    </div>
                    <div
                      className={"placar-lado"}
                      style={{
                        background:
                          euNaFrente || empate
                            ? empate
                              ? "#F4F8F9"
                              : "#FFE5E0"
                            : "#E0F5F0",
                      }}
                    >
                      <div className={"placar-nome"}>
                        {opon?.nome.split(" ")[0]}
                      </div>
                      <div
                        className={"placar-val"}
                        style={{
                          color:
                            euNaFrente || empate
                              ? empate
                                ? "#1F4754"
                                : "#B83A2E"
                              : "#1A7A6E",
                        }}
                      >
                        {fmtNum(oponVal, 1)}
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 11,
                      color: "#6B8590",
                      textAlign: "center",
                    }}
                  >
                    {crit?.unidade}
                    {"s - Aposta: "}
                    {fmtNum(ativo.aposta)}
                    {" tokens cada - Premio: "}
                    {fmtNum(2 * ativo.aposta)}
                    {" tokens"}
                  </div>
                  {ativo.descricao && (
                    <div
                      style={{
                        fontSize: 12,
                        color: "#6B8590",
                        fontStyle: "italic",
                        marginTop: 6,
                      }}
                    >
                      {'"'}
                      {ativo.descricao}
                      {'"'}
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      )}
      {"hist" === aba && (
        <div>
          <div className={"dv dv-dark"}>
            <span>{"Histórico"}</span>
          </div>
          {0 === finalizados.length ? (
            <div className={"es"}>
              <h3>{"Nenhum desafio finalizado ainda"}</h3>
            </div>
          ) : (
            finalizados.map((finalizado) => {
              const venci = finalizado.vencedor_id === currentStudent.id;
              const emp = "empate" === finalizado.status;
              const souDes = finalizado.desafiante_id === currentStudent.id;
              const meuVal = souDes
                ? finalizado.val_desafiante
                : finalizado.val_desafiado;
              const oponVal = souDes
                ? finalizado.val_desafiado
                : finalizado.val_desafiante;
              const opon = students.find(
                (student) =>
                  student.id ===
                  (souDes ? finalizado.desafiado_id : finalizado.desafiante_id),
              );
              return (
                <div
                  style={{
                    background: "#FFF",
                    borderRadius: 12,
                    padding: "12px 13px",
                    marginBottom: 8,
                    borderLeft: "4px solid ".concat(
                      emp ? "#F59E0B" : venci ? "#4FB3A9" : "#D9534F",
                    ),
                    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                  }}
                  key={finalizado.id}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                    }}
                  >
                    <div>
                      <div
                        style={{
                          fontSize: 13,
                          fontWeight: 700,
                          color: "#1F4754",
                        }}
                      >
                        {"vs "}
                        {opon?.nome}
                      </div>
                      <div
                        style={{
                          fontSize: 11,
                          color: "#6B8590",
                          marginTop: 2,
                        }}
                      >
                        {finalizado.criterio_label}
                        {" - "}
                        {fmtDateFull(finalizado.data_fim)}
                      </div>
                      {null !== meuVal && (
                        <div
                          style={{
                            fontSize: 11,
                            color: "#6B8590",
                            marginTop: 2,
                          }}
                        >
                          {"Você: "}
                          {fmtNum(meuVal, 1)}
                          {" / "}
                          {opon?.nome.split(" ")[0]}
                          {": "}
                          {fmtNum(oponVal, 1)}
                        </div>
                      )}
                    </div>
                    <div
                      style={{
                        textAlign: "right",
                        flexShrink: 0,
                        marginLeft: 8,
                      }}
                    >
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 800,
                          color: emp
                            ? "#F59E0B"
                            : venci
                              ? "#4FB3A9"
                              : "#D9534F",
                        }}
                      >
                        {emp ? "EMPATE" : venci ? "VITORIA" : "DERROTA"}
                      </div>
                      <div
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: emp
                            ? "#F59E0B"
                            : venci
                              ? "#4FB3A9"
                              : "#D9534F",
                        }}
                      >
                        {emp
                          ? "devolvido"
                          : venci
                            ? "+".concat(fmtNum(finalizado.aposta), " tok")
                            : "-".concat(fmtNum(finalizado.aposta), " Tokens")}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}
        </div>
      )}
    </div>
  );
}
